import * as React from "react";
import { renderStartsIn } from "./renderStartsIn";
export var renderKickOffState = function (event, componentPrefix, dict) {
    return React.createElement("div", { className: "rj-ev-list__" + componentPrefix + "__section-item rj-ev-list__" + componentPrefix + "__times", "data-uat": "div-ev-list-" + componentPrefix + "-times" }, renderStartsIn(dict.StartsIn, event.kickOffTime ? dict.ClockMins.format(event.kickOffTime) : ""));
};
//# sourceMappingURL=renderKickOffState.js.map